module.exports = __webpack_public_path__ + "static/media/github.6c03dbe1.png";